import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import green_tick from "../../../images/green_tick.png";
import tick from "../../../images/tick.png";
import cross_icon from "../../../images/red_cross.png";
import { Link, useParams } from 'react-router-dom';
import Header from '../../Includes/Header';
import { useNavigate } from 'react-router-dom';
import countriesData from '../../../data/countries.json';
import { useState, useRef, useEffect } from 'react';
import countriesStateData from '../../../data/states.json';
import { toHaveFormValues } from '@testing-library/jest-dom/matchers';
import BackButton from '../../Includes/BackButtonEntityAccount';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../../renderField';
import { connect } from 'react-redux';
import { setwizardPageName, setwizardPageNumber, setEmailVerify, setUserID, setEntityAccountUserDetails, setEntityAccountBusinessDetails, setBusinessAddressDetails, setPhysicalBusinessAddressDetails } from '../../EntityAccountReducer';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import red_cross_icon from "../../../images/circle_cross.png";
import config from '../../../config';
import axios, { AxiosError } from 'axios';
import { updateEntityKycDraftStep, uploadEntityKycDraftFiles } from '../../../Utils/entityKycDraft';
import CountryDropdown from 'MyComponents/UI/CountryDropdown';
import MultiFileSelector from './FilePicker';
import { propTypes } from 'react-bootstrap/esm/Image';
import { useTranslation } from 'react-i18next';

interface Props { };

interface FormData {
  physicalBusinessAddressCity: string;
  physicalBusinessAddressZip: string;
  physicalBusinessStreetAddress: string;
}

interface UploadedFile {
  filename: string;
  url: string;
}


const PhysicalBusinessAddressForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);
  const email = useSelector((state: RootState) => state.entityAccount.email);
  const entityAccountBusinessDetails = useSelector((state: RootState) => state.entityAccount.entityAccountBusinessDetails);
  const { userId } = useParams<{ userId?: string }>();

  const [validated, setValidated] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState<UploadedFile[]>(props.initialValues?.physicalBusinessProofOfAddress || []);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [selectedCountry, setSelectedCountry] = useState(props.initialValues?.physicalBusinessAddressCountry);
  const [countryValidation, setCountryValidation] = useState(false);

  const [selectedState, setSelectedState] = useState(props.initialValues?.physicalBusinessAddressState);
  const [stateValidation, setStateValidation] = useState(false);



  useEffect(() => {
    if (props.initialValues) {
      const vals = props.initialValues;
      if (vals.physicalBusinessAddressCountry) setSelectedCountry(vals.physicalBusinessAddressCountry);
      if (vals.physicalBusinessAddressState) setSelectedState(vals.physicalBusinessAddressState);
      if (vals.isBusinessOfficeOrRemote) setIsBusinessOfficeOrRemote(vals.isBusinessOfficeOrRemote);
      if (vals.physicalBusinessProofOfAddress) setUploadedDocument(vals.physicalBusinessProofOfAddress);
    }
  }, [props.initialValues]);

  useEffect(() => {
    dispatch(setwizardPageName("physicalBusinessAddress"));
  }, [dispatch]);

  useEffect(() => {
    if (uploadedDocument && uploadedDocument.length > 0) {
      setValidated(false);
    }
  }, [uploadedDocument]);


  const handleCountryClick = (countryName: any) => {
    setSelectedCountry(countryName);
    setCountryValidation(false);
  };

  const validateCity = (value: any) => {
    if (!value) {
      return 'City is required';
    }
  };

  const validatePostalCode = (value: any) => {
    if (!value) {
      return 'Postal code is required';
    }
  };

  const validatePhysicalBusinessStreetAddress = (value: any) => {
    if (!value) {
      return 'Street address is required';
    }
  };


  const handleStateClick = (stateName: any) => {
    setSelectedState(stateName);
    setStateValidation(false);
  };
  const [isBusinessOfficeOrRemote, setIsBusinessOfficeOrRemote] = useState(props.initialValues?.isBusinessOfficeOrRemote || 'Business Office');
  const handleIsBusinessOfficeOrRemote = (event: any) => {
    const selectedValue = event.target.value;
    setIsBusinessOfficeOrRemote(selectedValue);
  };

  const savePhysicalBusinessAddressDetails = async (
    ssoUserID: string,
    email: String,
    isBusinessOfficeOrRemote: String,
    physicalBusinessAddressCountry: String,
    physicalBusinessAddressCity: String,
    physicalBusinessAddressState: String,
    physicalBusinessAddressZip: String,
    physicalBusinessStreetAddress: String,
    physicalBusinessProofOfAddress: UploadedFile[],
    files?: File[]
  ) => {
    try {
      let updatedDocuments = [...physicalBusinessProofOfAddress];

      if (files && files.length > 0) {
        const uploadedNewFiles = await uploadEntityKycDraftFiles(ssoUserID, files);
        if (uploadedNewFiles) {
           updatedDocuments = [...updatedDocuments, ...uploadedNewFiles];
        }
      }

      const payload = {
        email,
        isBusinessOfficeOrRemote,
        physicalBusinessAddressCountry,
        physicalBusinessAddressCity,
        physicalBusinessAddressState,
        physicalBusinessAddressZip,
        physicalBusinessStreetAddress,
        physicalBusinessProofOfAddress: updatedDocuments
      };

      const response = await updateEntityKycDraftStep(ssoUserID, "physicalBusinessAddress", payload);
      return response;
    } catch (error: any) {
      console.error(error);
      notifyError("Something Went Wrong");
      return null;
    }
  };


  const submitPhysicalBusinessAddressForm = async (formValues: FormData) => {
    if (selectedCountry == '') {
      setCountryValidation(true);
      return;
    }

    if (selectedState == '') {
      setStateValidation(true);
      return;
    }

    const city = formValues.physicalBusinessAddressCity;
    const postalCode = formValues.physicalBusinessAddressZip;
    const streetAddress = formValues.physicalBusinessStreetAddress;
    const ssoUserID = userId || ""

    if (uploadedDocument.length === 0 && pendingFiles.length === 0) {
      setValidated(true);
      return;
    }

    const physicalBusinessAddressDetailsObject = { isBusinessOfficeOrRemote: isBusinessOfficeOrRemote, physicalBusinessAddressCountry: selectedCountry, physicalBusinessAddressCity: city, physicalBusinessAddressState: selectedState, physicalBusinessAddressZip: postalCode, physicalBusinessStreetAddress: streetAddress, physicalBusinessProofOfAddress: uploadedDocument };
    console.log("Physical Business Address Details: ", physicalBusinessAddressDetailsObject);
    dispatch(setPhysicalBusinessAddressDetails(physicalBusinessAddressDetailsObject));
    const Response = await savePhysicalBusinessAddressDetails(
      ssoUserID,
      email,
      isBusinessOfficeOrRemote,
      selectedCountry,
      city,
      selectedState,
      postalCode,
      streetAddress,
      uploadedDocument,
      pendingFiles
    );
    console.log("Response", Response);
    if (Response) {
      dispatch(setwizardPageName("accountUse"));
      dispatch(setwizardPageNumber(6));
      localStorage.setItem('pageName', "accountUse");
      localStorage.setItem('pageNumber', '6');
    }


  };


  return (
    <>
      <div className="pt-0 pb-3 mb-5 col-md-11 mx-auto px-2">
        <div className="row justify-content-center">
          <Col md={11}>
            <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
            <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p>
            <h4 className="mt-3">{t('kyc.physical_business_address')}</h4>
            <p className="text-secondary small">
              {t('kyc.physical_address_desc')}
            </p>
          </Col>
        </div>

        <div className="row justify-content-center">
          <Col md={11}>
            <Form
              noValidate={true}
              onSubmit={handleSubmit(submitPhysicalBusinessAddressForm)}
            >
              <div className="mt-4 row mb-3">
                <Col md={12}>
                  <label className="form-label fw-bold  ">
                    {t('kyc.office_or_remote_q')}
                  </label>
                  <select
                    className="form-control form-select rounded-5 px-3 py-2"
                    onChange={handleIsBusinessOfficeOrRemote}
                    value={isBusinessOfficeOrRemote}
                  >
                    <option value="Business Office">{t('kyc.business_office')}</option>
                    <option value="Remote">{t('kyc.remote_company')}</option>
                  </select>
                </Col>
              </div>
              <CountryDropdown
                countriesData={countriesData}
                selectedCountry={selectedCountry}
                handleCountryClick={handleCountryClick}
                countryValidation={countryValidation}
              />
              <div className="mb-3 mt-4 row">
                <Col md={4}>
                  <label className="form-label fw-bold  ">{t('profile.city')}</label>
                  <Field
                    name="physicalBusinessAddressCity"
                    type="text"
                    component={renderField}
                    placeholder={t('kyc.type_city')}
                    id="physicalBusinessAddressCity"
                    validate={validateCity}
                  />
                </Col>
                <Col md={4}>
                  <label className="form-label fw-bold  ">{t('kyc.state_province')}</label>
                  <div className="dropdown">
                    <Button
                      className="form-control form-select rounded-5 text-start px-3 mt-1 btn border bg-white text-secondary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      variant=""
                    >
                      {selectedState ? selectedState : t('kyc.select_state')}
                    </Button>
                    <ul className="dropdown-menu min-width-auto rounded-4 hide-scroll shadow border-0">
                      {countriesStateData.map(
                        (country) =>
                          country.name === selectedCountry &&
                          country.states &&
                          country.states.map((state) => (
                            <li
                              key={state.id}
                              className="dropdown-item"
                              onClick={() => handleStateClick(state.name)}
                            >
                              {state.name}
                            </li>
                          ))
                      )}
                    </ul>
                  </div>
                  <div
                    id="state_validation"
                    className={stateValidation ? "" : "d-none"}
                  >
                    <small className="text-danger">{t('kyc.state_required')}</small>
                  </div>
                </Col>
                <Col md={4}>
                  <label className="form-label fw-bold ">{t('kyc.zip_postal')}</label>
                  <Field
                    name="physicalBusinessAddressZip"
                    type="text"
                    component={renderField}
                    placeholder={t('kyc.type_code')}
                    id="physicalBusinessAddressZip"
                    validate={validatePostalCode}
                  />
                </Col>
              </div>

              <div className="mb-3 mt-4 row">
                <label className="form-label fw-bold ">{t('kyc.street_address')}</label>
                <Col md={6}>
                  <p className="text-secondary small">
                    {t('kyc.street_address_note')}
                  </p>
                </Col>
                <Col md={6}>
                  <p className="text-secondary small m-0">
                    <img src={cross_icon} />
                    &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.no_po_boxes')}
                  </p>
                  <p className="text-secondary small m-0">
                    <img src={cross_icon} />
                    &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.no_mail_forwarding')}
                  </p>
                  <p className="text-secondary small m-0">
                    <img src={cross_icon} />
                    &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.no_registered_agent')}
                  </p>
                </Col>
              </div>

              <div className="row mb-3 mt-4">
                <Field
                  name="physicalBusinessStreetAddress"
                  type="text"
                  component={renderField}
                  shouldRound={false}
                  placeholder={t('kyc.enter_street_ph')}
                  id="physicalBusinessStreetAddress"
                  validate={validatePhysicalBusinessStreetAddress}
                />
              </div>

              <div>
                <label className="form-label fw-bold">
                  {t('kyc.proof_address_label')}
                </label>
                <p className="text-secondary small">
                  {t('kyc.proof_address_desc')}
                </p>
                <p className=" fw-bold mt-3">{t('kyc.proof_address_ensure')}</p>
                <ul className="p-0 border-0 bg-transparent text-secondary small">
                  <li className="list-group-item border-0 bg-transparent">
                    {t('kyc.proof_match')}
                  </li>
                  <li className="list-group-item border-0 bg-transparent ">
                    {t('kyc.proof_business_name')}
                  </li>
                  <li className="list-group-item border-0 bg-transparent">
                    {t('kyc.proof_dated_90')}
                  </li>
                </ul>

                <div className="row mb-3 mt-4">
                  <label className=" fw-bold form-label">
                    {t('kyc.upload_proof_address')}
                  </label>
                  <Col md={12} className="pb-1">
                    <MultiFileSelector
                      maxFiles={5}
                      maxFileSizeMB={20}
                      existedFiles={uploadedDocument}
                      onFilesChange={(files) => {
                        setUploadedDocument(files)
                      }}
                      onPendingFilesChange={(files) => {
                        setPendingFiles(files)
                      }}
                    />
                  </Col>

                  {validated && (
                    <p className="text-danger fw-bold small text-start">
                      {t('kyc.upload_proof_required')}
                    </p>
                  )}
                </div>

                <div className="row mt-3 mb-1">
                  <Col md={12}>
                    <Button
                      type="submit"
                      className="btn btn-secondary rounded-5  mt-2 border-0"
                      style={{ background: "#0B1628" }}
                    >
                      {t('common.save_continue')}
                    </Button>
                  </Col>
                </div>
              </div>
            </Form>
          </Col>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    isBusinessOfficeOrRemote: state.entityAccount.physicalBusinessAddressDetails.isBusinessOfficeOrRemote,
    physicalBusinessAddressCountry: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessAddressCountry,
    physicalBusinessAddressCity: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessAddressCity,
    physicalBusinessAddressState: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessAddressState,
    physicalBusinessAddressZip: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessAddressZip,
    physicalBusinessStreetAddress: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessStreetAddress,
    physicalBusinessProofOfAddress: state.entityAccount.physicalBusinessAddressDetails.physicalBusinessProofOfAddress,
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: 'wizardPhysicalBusinessinfo',
  enableReinitialize: true,
})(PhysicalBusinessAddressForm);

export default connect(mapStateToProps)(form);
